module.exports = __webpack_public_path__ + "static/registrar-12de994be9aceaba1e3b3d3f8b673320.jpg";